module.exports = __webpack_public_path__ + "img/font_minus.4412d72a.svg";